import axios from "axios";

import type { AdminAnalyticsDashboardResponse } from "@virtual-brain-lib/types";

import env from "../environments";
import { queryOptions } from "../query-client";

const FREEZE_DASHBOARD_RESULT_FOR_5_MINUTES = 5 * 60 * 1000;

export const getAdminAnalyticsDashboard = queryOptions({
	staleTime: FREEZE_DASHBOARD_RESULT_FOR_5_MINUTES,
	async queryFn({ queryKey }): Promise<AdminAnalyticsDashboardResponse> {
		const [, params] = queryKey;
		const response = await axios.get<AdminAnalyticsDashboardResponse>(
			`${env.apiUrl}/admin-analytics/dashboard`,
			{
				// Axios serializes id arrays as `?userIds[]=a&userIds[]=b` by default, which Express parses to string[].
				params: {
					from: params.from,
					to: params.to,
					granularity: params.granularity,
					userIds: params.userIds,
					teamIds: params.teamIds,
					appIds: params.appIds,
					appStatus: params.appStatus,
				},
			},
		);

		return response.data;
	},
	queryKey: "adminAnalyticsDashboard",
});
